(ns io.daskul.webapp.widgets.segmented-filter-bar.scroll
  "Pure horizontal-scroll geometry for the segmented filter bar (#622).

   No React/DOM import so it runs under the :node-test build — the component
   reads the numbers off the DOM and hands them here."
  (:require
   [clojure.string :as str]))

(def fade-px
  "Width of the edge fade that signals 'there is more this way'."
  24)

(def ^:private pad-px
  "Breathing room kept between a scrolled-to segment and the edge, so the
   segment never sits flush against the fade that's obscuring it."
  (+ fade-px 8))

(defn scroll-left-for
  "The `scrollLeft` that brings a segment fully into view, with `pad` px of
   breathing room on the side it was clipped.

   Returns `scroll-left` unchanged when the segment is already comfortably
   visible, so selecting a segment that's on screen never jumps the bar.
   `el-left` is the segment's offset from the start of the scrollable content
   (i.e. including whatever is currently scrolled out to the left)."
  ([scroll-left client-width el-left el-width]
   (scroll-left-for scroll-left client-width el-left el-width pad-px))
  ([scroll-left client-width el-left el-width pad]
   (let [el-right (+ el-left el-width)
         view-right (+ scroll-left client-width)]
     (cond
       ;; Clipped on the left (or hidden behind the left fade) — pull it right.
       (< el-left (+ scroll-left pad))
       (max 0 (- el-left pad))

       ;; Clipped on the right — pull it left, but never past the start.
       (> el-right (- view-right pad))
       (max 0 (- (+ el-right pad) client-width))

       :else scroll-left))))

(defn scrollable-edges
  "Which sides have content beyond the visible box: {:left? :right?}.

   A 1px tolerance absorbs subpixel rounding, so a bar that fits exactly
   doesn't render a fade over its own last segment."
  [scroll-left scroll-width client-width]
  (let [max-scroll (- scroll-width client-width)]
    {:left? (> scroll-left 1)
     :right? (< scroll-left (- max-scroll 1))}))

(defn edge-mask
  "CSS `mask-image` fading whichever edges have more content beyond them, or
   nil when everything fits — an unconditional fade would dim the last segment
   of a bar that isn't scrollable at all."
  [{:keys [left? right?]}]
  (let [start (str "transparent 0, #000 " fade-px "px")
        end (str "#000 calc(100% - " fade-px "px), transparent 100%")]
    (when (or left? right?)
      (str "linear-gradient(to right, "
           (str/join ", " (cond-> []
                            left? (conj start)
                            (not left?) (conj "#000 0")
                            right? (conj end)
                            (not right?) (conj "#000 100%")))
           ")"))))
